/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import * as React from "react";
import Alert from "../../components/LoadingAlert";

export default class NotFound extends React.Component {
    render() {
        return (<Alert type="danger">Page not found...</Alert>);
    }
}